export enum ReconstructionSpace {
    Specimen = 0,
    Atlas = 1
}
